import React from 'react';
import { useDispatch } from 'react-redux';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { alpha, lighten, styled } from '@mui/material/styles';

import { setSelectedFlow } from '../../../../../actions/casesActions';

import {
  procedureFlows,
  selectedProcedureFlows,
} from '../../../../../constants/cases';

import matortho_image from '../../../../../assets/step0/PS_Matortho_Image.png';

const matorthoColor = '#AA2415';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,

  '& .block-header': {
    width: '90%',
    marginTop: 10,
    marginBottom: 25,
  },
}));

const StyledListItem = styled(ListItem)(({ selected, theme }) => ({
  borderRadius: 20,
  border: `2px solid ${matorthoColor}`,
  cursor: 'pointer',
  color: theme.palette.text.primary,
  backgroundColor: selected
    ? `${theme.palette.mode === 'dark'
      ? alpha(matorthoColor, 0.32)
      : lighten(matorthoColor, 0.95)} !important`
    : 'var(--color-surface)',
  '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
    color: selected
      ? (theme.palette.mode === 'dark' ? theme.palette.text.primary : undefined)
      : undefined,
  },
  '& img': {
    filter: selected && theme.palette.mode !== 'dark' ? 'brightness(1.05) contrast(1.05)' : 'none',
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    fontSize: '1.2rem',
    fontWeight: 600,
    letterSpacing: 1.5,
    color: theme.palette.text.primary,
  },
  '& .MuiListItemText-secondary': {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
}));

export const Step0Matortho = ({ selected, onChange, procedures = [] }) => {
  const dispatch = useDispatch();

  const handleProcedureFlowClick = (event, flow) => {
    onChange(flow);
    dispatch(setSelectedFlow(flow));
  };

  return (
    <Container>
      <div className="block-header">Select Procedure</div>

      <Grid container aria-label="procedures" sx={{ width: '95%' }} spacing={3}>
        {procedures.some((procedure) => procedure.flow === procedureFlows.MATORTHO_KNEE) && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <StyledListItem
              button
              selected={selected === selectedProcedureFlows.MATORTHO_KNEE}
              onClick={(event) =>
                handleProcedureFlowClick(event, selectedProcedureFlows.MATORTHO_KNEE)
              }
            >
              <img src={matortho_image} alt="MATORTHO_KNEE" width="70" height="70" style={{ marginRight: '16px' }} />
              <StyledListItemText
                primary="Matortho Knee"
                secondary="Patient Specific Instrumentation"
              />
            </StyledListItem>
          </Grid>
        )}

        {procedures.some((procedure) => procedure.flow === procedureFlows.MATORTHO_HIP) && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <StyledListItem
              button
              selected={selected === selectedProcedureFlows.MATORTHO_HIP}
              onClick={(event) =>
                handleProcedureFlowClick(event, selectedProcedureFlows.MATORTHO_HIP)
              }
            >
              <img src={matortho_image} alt="MATORTHO_HIP" width="70" height="70" style={{ marginRight: '16px' }} />
              <StyledListItemText
                primary="Matortho Hip"
                secondary="Patient Specific Instrumentation"
              />
            </StyledListItem>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
